import { FrameEmptyState } from "@/components/shapes/shared/frame-empty-state";
import type { FrameProps } from "@/components/shapes/shared/frame-props";
import { cardPaint } from "../shared/card-paint";
import { ObjectFrame, ObjectFrameLoading } from "../shared/object-frame";
import { hasTrack, musicFields } from "./music-content";
import { MusicFace } from "./music-face";
import { MusicPlayer } from "./music-player";
import { useT } from "@/i18n";
import { musicFrameMessages } from "@/i18n/messages/frames-music";

/**
 * A track: its card, larger, with the Spotify player in place of the play
 * mark. A track with only a Spotify id is the player alone, on plain paper
 * like its card. Content is `{track, artist, embedId?}`; agent updates
 * re-render it.
 */
export function MusicFrame({ id, data }: FrameProps) {
  const t = useT(musicFrameMessages);
  const fields = musicFields(data.content ?? {});
  return (
    <ObjectFrame id={id} paint={cardPaint(data)} testId="music-frame">
      {hasTrack(fields) ? (
        <MusicFace
          fields={fields}
          density="regular"
          opened
          testIdPrefix="music-frame"
        />
      ) : fields.embedId ? (
        <div className="flex flex-1 flex-col justify-end p-[1.4em]">
          <MusicPlayer embedId={fields.embedId} track="" artist="" />
        </div>
      ) : data.status === "streaming" ? (
        <ObjectFrameLoading testId="music-frame-loading">
          {t("findingTrack")}
        </ObjectFrameLoading>
      ) : (
        <FrameEmptyState
          frameId={id}
          status={data.status}
          testId="music-frame-empty"
        >
          {t("noTrack")}
        </FrameEmptyState>
      )}
    </ObjectFrame>
  );
}
